import React from "react";

export function ThinkingDots() {
  return (
    <div className="flex gap-2 items-center">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="w-1 h-1 bg-white rounded-full"
          style={{
            animation: `thinkingDot 1.2s ease-in-out infinite`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </div>
  );
}

export function LoadingBlocks() {
  const blocks = [
    { row: 0, col: 0, delay: 0 },
    { row: 0, col: 1, delay: 0.1 },
    { row: 1, col: 0, delay: 0.2 },
    { row: 1, col: 1, delay: 0.3 },
    { row: 2, col: 0, delay: 0.4 },
  ];

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="grid grid-cols-2 gap-2 h-[52px]">
        {blocks.slice(0, 2).map((block, i) => (
          <div
            key={i}
            className="bg-[rgba(251,106,7,0.2)] rounded"
            style={{
              animation: `loadingBlock 1.5s ease-in-out infinite`,
              animationDelay: `${block.delay}s`,
            }}
          />
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2 h-[52px]">
        {blocks.slice(2, 4).map((block, i) => (
          <div
            key={i}
            className="bg-[rgba(251,106,7,0.2)] rounded"
            style={{
              animation: `loadingBlock 1.5s ease-in-out infinite`,
              animationDelay: `${block.delay}s`,
            }}
          />
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2 h-[52px]">
        <div
          className="bg-[rgba(251,106,7,0.2)] rounded"
          style={{
            animation: `loadingBlock 1.5s ease-in-out infinite`,
            animationDelay: `${blocks[4].delay}s`,
          }}
        />
        <div className="border-2 border-dashed border-[rgba(251,106,7,0.2)] rounded" />
      </div>

      <style>{`
        @keyframes thinkingDot {
          0%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.2);
          }
        }

        @keyframes loadingBlock {
          0%, 100% {
            opacity: 0.2;
          }
          50% {
            opacity: 0.8;
          }
        }
      `}</style>
    </div>
  );
}
